import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FiSearch } from "react-icons/fi";

const SearchDropdown = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const decodeHtml = (html) => {
    const parser = new DOMParser();
    const decoded = parser.parseFromString(html, "text/html").body.textContent;
    return decoded || html;
  };

  useEffect(() => {
    const fetchSuggestions = async () => {
      if (!searchTerm.trim()) {
        setSuggestions([]);
        return;
      }

      setIsLoading(true);
      try {
        const res = await fetch(
          `https://blognxa.wpcomstaging.com/wp-json/wp/v2/posts?search=${encodeURIComponent(
            searchTerm
          )}`
        );
        const data = await res.json();
        setSuggestions(data);
      } catch (err) {
        console.error("Search API error:", err);
        setSuggestions([]);
      } finally {
        setIsLoading(false);
      }
    };

    const delayDebounce = setTimeout(fetchSuggestions, 300);
    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  const handleSelect = (post) => {
    navigate(`/blog-details/${post.slug}`);
    setSearchTerm("");
    setSuggestions([]);
  };

  return (
    <div className="search-dropdown">
      <FiSearch className="search-dropdown__icon" />
      <input
        type="text"
        placeholder="Search blog..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      {isLoading && <span className="search-dropdown__loader"></span>}
      {suggestions.length > 0 && (
        <ul className="suggestions">
          {suggestions.map((post) => (
            <li key={post.id} onClick={() => handleSelect(post)}>
              {decodeHtml(post.title.rendered)}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SearchDropdown;
